import Model, { attr } from '@ember-data/model';

export default class JournalStageModel extends Model {
  @attr('string') declare name: string;
  @attr('number') declare sortOrder: number;
  @attr('boolean') declare decisionStage: boolean;
  @attr('boolean') declare askStage: boolean;
  @attr('string') lastTaskActionId?: string;
  @attr('string') lastTaskMediumId?: string;
  @attr('number') weeklyGoal?: number;
}
